export default "__VITE_ASSET__d13089b0__"